import React from 'react';
import styled, { keyframes } from 'styled-components';
import { prop } from 'styled-tools';

/*
 * Styles
 */

const CircleIn = keyframes`
  0% {
    opacity: 0;
    transform: scale(0.5);
  }
`;

const Circle = styled.circle`
  animation: ${CircleIn} 1800ms 900ms ${prop('theme.settings.easings.quintOut')} 1 backwards};
  fill: none;
  stroke: ${prop('theme.colors.grayT')};
  stroke-dasharray: 5 5;
  stroke-width: 1px;
  &:nth-of-type(2) {
    animation-delay: 1050ms;
  }
  &:nth-of-type(3) {
    animation-delay: 1200ms;
  }
`;

/*
 * Component
 */

const HaloAxesArcs = (props) => {
  const { count, pieSize, radius } = props;

  return (
    [...Array(count).keys()].map((n) => {
      return (
        <Circle
          key={n}
          r={radius - (n * pieSize / 4)}
        />
      )
    })
  )
};

export default HaloAxesArcs;
